const theme = {
  colors: {
    primary: "#8B4513", // חום כהה
    secondary: "#D2B48C", // חום בהיר
    accent: "#DEB887", // חום-זהב
    background: "#F5F5DC", // בז' בהיר
    text: "#4A4A4A", // אפור כהה
    white: "#FFFFFF",
    error: "#D32F2F",
    success: "#388E3C",
    errorDark: "#B71C1C",
    primaryDark: "#6B3410",
    border: "#E0E0E0",
  },
  fonts: {
    primary: "'Cardo', serif",
    secondary: "'Noto Sans Hebrew', serif",
  },
  fontSizes: {
    small: "0.875rem",
    medium: "1rem",
    large: "1.25rem",
    xlarge: "1.5rem",
    xxlarge: "2rem",
  },
  spacing: {
    xs: "0.25rem",
    sm: "0.5rem",
    md: "1rem",
    lg: "1.5rem",
    xl: "2rem",
    xxl: "3rem",
  },
  breakpoints: {
    mobile: "320px",
    tablet: "768px",
    desktop: "1024px",
    wide: "1280px",
  },
  borderRadius: {
    small: "4px",
    medium: "8px",
    large: "16px",
  },
  shadows: {
    small: "0 2px 4px rgba(0,0,0,0.1)",
    medium: "0 4px 8px rgba(0,0,0,0.1)",
    large: "0 8px 16px rgba(0,0,0,0.1)",
  },
};

export default theme;
